/* 
Tool Cool Range Slider - Marks Plugin v1.0.1
https://github.com/mzusin/toolcool-range-slider 
MIT License        
Copyright (c) 2022-present, Miriam Zusin                         
*/
(function () {
  var R = function R(r, n, t, c, d) {
    var a = n - r;
    return a === 0 ? t : (c - t) * (d - r) / a + t;
  },
      I = function I(r) {
    return !isNaN(parseFloat(r)) && isFinite(r);
  },
      g = function g(r, n) {
    return I(r) ? Number(r) : n;
  };

  var h = function h(r) {
    return r == null ? !1 : typeof r == "boolean" ? r : r.trim().toLowerCase() === "true";
  };

  window.tcRangeSliderPlugins = window.tcRangeSliderPlugins || [];

  var p = 11,
      y = 11,
      A = function A() {
    var r = null,
        n = null,
        t = null,
        c = null,
        d = null,
        a = !1,
        s = p,
        u = y,
        L = function L() {
      var l;
      var e = (l = r == null ? void 0 : r.shadowRoot) == null ? void 0 : l.querySelector("#range-slider");
      t = document.createElement("div"), t.classList.add("marks"), c = document.createElement("div"), c.classList.add("mark-points"), t.append(c), d = document.createElement("div"), d.classList.add("mark-values"), t.append(d), e.append(t);
    },
        P = function P() {
      !n || !t || t.classList.toggle("is-reversed", n.isRightToLeft() || n.isBottomToTop());
    },
        S = function S() {
      var v;
      if (!t || !n) return;
      var e = n.getMin(),
          l = n.getMax(),
          E = n.getType() === "vertical",
          f = n.isRightToLeft() || n.isBottomToTop();

      for (var i = 0; i < s; i++) {
        var o = document.createElement("div");
        o.classList.add("mark", "mark-".concat(i));
        var m = s === 0 ? 0 : i * 100 / (s - 1);
        E ? f ? o.style.top = "".concat(100 - m, "%") : o.style.top = "".concat(m, "%") : f ? o.style.left = "".concat(100 - m, "%") : o.style.left = "".concat(m, "%"), c == null || c.append(o);
      }

      var b = n.getData();

      for (var _i = 0; _i < u; _i++) {
        var _o = document.createElement("div");

        _o.classList.add("mark-value", "mark-value-".concat(_i));

        var _m = u === 0 ? 0 : _i * 100 / (u - 1),
            w = R(0, u - 1, e, l, _i);

        _o.textContent = (b ? (v = b[Math.round(w)]) != null ? v : "" : w).toString(), E ? f ? _o.style.top = "".concat(100 - _m, "%") : _o.style.top = "".concat(_m, "%") : f ? _o.style.left = "".concat(100 - _m, "%") : _o.style.left = "".concat(_m, "%"), d == null || d.append(_o);
      }
    },
        k = function k(e, l) {
      T(), s = e, u = l, s <= 0 && (s = p), u <= 0 && (u = y), L(), S(), P();
    },
        C = function C(e) {
      a = e, a ? (L(), S(), P()) : T();
    },
        x = function x(e) {
      !t || t.style.setProperty("--marks-color", e);
    },
        M = function M(e) {
      !t || t.style.setProperty("--values-color", e);
    },
        T = function T() {
      t == null || t.remove();
    };

    return {
      get name() {
        return "Marks";
      },

      init: function init(e, l, E, f) {
        var b, v;
        n = f, r = e, a = h(r.getAttribute("marks")), a && (k(g(r.getAttribute("marks-count"), p), g(r.getAttribute("marks-values-count"), y)), x((b = r.getAttribute("marks-color")) != null ? b : "#cbd5e1"), M((v = r.getAttribute("marks-values-color")) != null ? v : "#475569"));
      },
      onAttrChange: function onAttrChange(e, l) {
        e === "marks" && C(h(l)), e === "marks-count" && k(g(l, p), u), e === "marks-values-count" && k(s, g(l, y)), e === "marks-color" && x(l), e === "marks-values-color" && M(l);
      },
      gettersAndSetters: [{
        name: "marksEnabled",
        attributes: {
          get: function get() {
            return a != null ? a : !1;
          },
          set: function set(e) {
            C(h(e));
          }
        }
      }, {
        name: "marksCount",
        attributes: {
          get: function get() {
            return s != null ? s : p;
          },
          set: function set(e) {
            k(g(e, p), u);
          }
        }
      }, {
        name: "marksValuesCount",
        attributes: {
          get: function get() {
            return s != null ? s : p;
          },
          set: function set(e) {
            k(s, g(e, y));
          }
        }
      }, {
        name: "marksColor",
        attributes: {
          get: function get() {
            return t == null ? void 0 : t.style.getPropertyValue("--marks-color");
          },
          set: function set(e) {
            x(e);
          }
        }
      }, {
        name: "markValuesColor",
        attributes: {
          get: function get() {
            return t == null ? void 0 : t.style.getPropertyValue("--values-color");
          },
          set: function set(e) {
            M(e);
          }
        }
      }],
      destroy: T,
      css: "\n:root{\n  --marks-color: #cbd5e1;\n  --values-color: #475569;\n}\n  \n.marks{\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  top: 100%;\n  left: 0;\n  color: var(--values-color, #475569);\n}\n\n.type-vertical .marks{\n  width: auto;\n  height: 100%;\n  top: 0;\n  left: 100%;\n  flex-direction: row;\n}\n    \n.mark-points{\n  width: 100%;\n  height: 1rem;\n  position: relative;\n  margin-top: 5px;\n}  \n\n.type-vertical .mark-points {\n  width: 1rem;\n  height: 100%;\n  margin-top: 0;\n  margin-left: 5px;\n}\n\n.mark-values{\n  width: 100%;\n  height: 1rem;\n  position: relative;\n}\n\n.type-vertical .mark-values {\n  width: 1rem;\n  height: 100%;\n  margin-left: 0.7rem;\n}\n\n.mark{\n  background: var(--marks-color, #cbd5e1);\n  width: 2px;\n  height: 5px;\n  position: absolute;\n  transform: translateX(-50%);\n}  \n\n.type-vertical .mark {\n    width: 5px;\n    height: 2px;\n    transform: translateY(-50%);\n}\n\n.mark-value{\n  position: absolute;\n  transform: translateX(-50%);\n}\n\n.type-vertical .mark-value{\n    transform: translateY(-50%);\n}\n    "
    };
  };

  window.tcRangeSliderPlugins.push(A);
  var $ = A;
})();